/** Base URL for admin-only API proxy endpoints */
export const ADMIN_BASE = '/api/admin';

/** Base URL for self-service API proxy endpoints */
export const SELF_BASE = '/api/self';
